import rootParams from './rootParams';

const getUserDataApi = async (navigate) => {
  const myHeaders = new Headers();
  const token = localStorage.getItem('token');
  myHeaders.append('Authorization', `bearer ${token}`);

  const requestOptions = {
    method: 'GET',
    headers: myHeaders,
    redirect: 'follow',
  };

  const baseUrl = `${rootParams.rootUrl}user/user-info`;

  const response = await fetch(baseUrl, requestOptions);

  if (!response.ok) {
    localStorage.clear();
    navigate('/auth/signin/keyExpired');
    throw new Error('Get user data Api failed');
  }

  return response.json();
};

export default getUserDataApi;
